import AttachmentsItemModel from './AttachmentsItemModel';

const AttachmentsElementModel = {
  elements: [],
};

export default AttachmentsElementModel;
